/* eslint-disable */
import ctype from 'component-type';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the type of a given `shortLabel` is invalid
 * @export
 * @class I18nInvalidShortLabelTypeError
 * @extends {Error}
 */
export class I18nInvalidShortLabelTypeError extends Error {
  /**
   * Creates an instance of I18nInvalidShortLabelTypeError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidShortLabelTypeError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidShortLabelTypeError`;
  }
}

/**
 * Called when the type of a given `shortLabel` is invalid
 * @param {any} shortLabel The invalid `shortLabel`
 * @returns {never} never
 */
const throwI18nInvalidShortLabelTypeError = (shortLabel) => {
  throw new I18nInvalidShortLabelTypeError(
    stripIndent(`
    Expected "shortLabel" to be of type String.
    Got: "${ctype(shortLabel)}".
    `),
  );
};

export default throwI18nInvalidShortLabelTypeError;
